import { render, staticRenderFns } from "./AddEntityGroup.vue?vue&type=template&id=589c9ea6&scoped=true"
import script from "./AddEntityGroup.vue?vue&type=script&lang=js"
export * from "./AddEntityGroup.vue?vue&type=script&lang=js"
import style0 from "./AddEntityGroup.vue?vue&type=style&index=0&id=589c9ea6&prod&lang=scss&scoped=true"
import style1 from "./AddEntityGroup.vue?vue&type=style&index=1&id=589c9ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c9ea6",
  null
  
)

export default component.exports